import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getRevenueMoMDedup } from 'dashboard/services/getRevenueMonthDedup';
import { getAllIndicatorsByDay, getAllIndicatorsByMonth } from 'dashboard/services/findIndicators';
import './Dashboard.css'
import { getTicketsAction } from 'tickets/services/store/actions';
import { getInvoices } from 'invoices/services/store/actions';
import { renderMoney } from 'common/services/util';
import { Button, ButtonGroup, IconButton, MenuItem, Select, Collapse } from '@material-ui/core';
import findTasksByState from 'dashboard/services/findTasksByState';
import getTicketsAmountToday, {
  getTicketsAmountTodayTotal,
  getTicketsAmountTodayByPaymentMode,
  PAYMENT_MODE
} from 'dashboard/services/filterTicketsToday';
import { getRevenueMoM } from 'dashboard/services/filterRevenueMonth';
import getInvoicesAmountMonth from 'dashboard/services/filterInvoicesMonth';
import getAmountTasksByPeriod from 'dashboard/services/graphics/createGraphicAmountTask';
import getAmountInvoicesByPeriod from 'dashboard/services/graphics/createGraphicAmountInvoice';
import getAmountTicketByPeriod from 'dashboard/services/graphics/createGraphicTicketInvoice';
import { ArrowBackIos, ArrowForwardIos, HourglassEmpty, SkipNext, Build, LocalShipping, FlightTakeoff, PhoneInTalk, AccessTime, Autorenew, LocalAtm, CreditCard, Receipt, ExpandMore, ExpandLess} from '@material-ui/icons';
import { getWorkshopAlertConfig } from "dashboard/services/getWorkshopAlertConfig";
import { getOpenTasksNow } from 'dashboard/services/getOpenTasksNow';
import { getWorkshopAlerts } from "dashboard/services/getWorkshopAlerts";
import RevenueTrendIcon from "dashboard/components/RevenueTrendIcon";
import getClientsTypeByPeriod from 'dashboard/services/graphics/createGraphicClientsType';
import { getTasks } from 'actions';
import { getTasksData } from 'common/store/reducers/tasks';
import { getTicketsList } from 'tickets/services/store/reducers';
import { getInvoicesData } from 'invoices/services/store/reducers';
import getNumberTasksByPeriod from 'dashboard/services/graphics/createGraphicNumberTask';
import Labels, { monthlyNames } from 'dashboard/services/graphics/labels';
import { getTasksRepairedByDay } from "dashboard/services/getTasksRepairedByDay";

class DashboardContainer extends Component {
    constructor(props) {
        super(props)
        this.state = {
           ticketsCashToday: getTicketsAmountTodayByPaymentMode(
            this.props.ticketsMap,
            PAYMENT_MODE.CASH
            ),
            ticketsCardToday: getTicketsAmountTodayByPaymentMode(
            this.props.ticketsMap,
            PAYMENT_MODE.CARD
            ),
            ticketsTotalToday: getTicketsAmountTodayTotal(this.props.ticketsMap),
            revenueMonth: getRevenueMoMDedup(this.props.ticketsMap, this.props.ticketDetailMap, this.props.invoicesMap).current,
            revenueMoMPercent: getRevenueMoMDedup(this.props.ticketsMap, this.props.ticketDetailMap, this.props.invoicesMap).percent,
            invoicesAmountMonth: getInvoicesAmountMonth(this.props.invoicesMap),
            waitingAmount: 0,
            waitingReplacementAmount: 0,
            rmaAmount: 0,
            period: 'daily',
            type: 0,
            indicatorsByDay: [],
            indicatorsByMonth: [],
            shiftPeriod: 0,
            openTasksNow: getOpenTasksNow(this.props.tasksMap),
            repairedToday: getTasksRepairedByDay(this.props.tasksMap, 0),
            repairedYesterday: getTasksRepairedByDay(this.props.tasksMap, -1),
        }
        this.charts = {
        tasksAmount: null,
        invoicesAmount: null,
        ticketsAmount: null,
        clientsType: null,
        numberTasks: null,
        };
        this._chartsTimer = null;
        this._indicatorsTimer = null;
    }

    componentDidMount() {
        const { getTickets, ticketsMap, getInvoices, invoicesMap, getTasks, tasksMap } = this.props

        if (Object.keys(ticketsMap || {}).length === 0) getTickets();
        if (Object.keys(invoicesMap || {}).length === 0) getInvoices();
        if (Object.keys(tasksMap || {}).length === 0) getTasks();

        this.updateTasksByState();
        this.updateIndicators();
    }

    componentDidUpdate(prevProps, prevState) {
        const prevLen = (prevProps.ticketsMap || []).length;
        const nextLen = (this.props.ticketsMap || []).length;

        if (prevLen !== nextLen || prevProps.ticketsMap !== this.props.ticketsMap) {
        this.setState({
            ticketsCashToday: getTicketsAmountTodayByPaymentMode(this.props.ticketsMap, PAYMENT_MODE.CASH),
            ticketsCardToday: getTicketsAmountTodayByPaymentMode(this.props.ticketsMap, PAYMENT_MODE.CARD),
            ticketsTotalToday: getTicketsAmountTodayTotal(this.props.ticketsMap),
        });
        }

        const prevTicketsLen = Object.keys(prevProps.ticketsMap || {}).length;
        const nextTicketsLen = Object.keys(this.props.ticketsMap || {}).length;

        const prevInvoicesLen = Object.keys(prevProps.invoicesMap || {}).length;
        const nextInvoicesLen = Object.keys(this.props.invoicesMap || {}).length;

        const ticketsChanged = prevProps.ticketsMap !== this.props.ticketsMap;
        const invoicesChanged = prevProps.invoicesMap !== this.props.invoicesMap;
        const ticketDetailChanged = prevProps.ticketDetailMap !== this.props.ticketDetailMap;

        if (ticketsChanged || invoicesChanged || ticketDetailChanged) {
        const mom = getRevenueMoMDedup(this.props.ticketsMap, this.props.ticketDetailMap, this.props.invoicesMap);
        this.setState({
            revenueMonth: mom.current,
            revenueMoMPercent: mom.percent
        });
        }

        if (prevProps.tasksMap !== this.props.tasksMap) {
            const openTasksNow = getOpenTasksNow(this.props.tasksMap);
            const repairedToday = getTasksRepairedByDay(this.props.tasksMap, 0);
            const repairedYesterday = getTasksRepairedByDay(this.props.tasksMap, -1);
            
            this.setState({
                openTasksNow,
                repairedToday,
                repairedYesterday,
            });

            // Actualizamos los estados de tareas cuando cambian
            this.updateTasksByState();
            
            // Actualizamos los indicadores cuando cambian las tareas
            clearTimeout(this._indicatorsTimer);
            this._indicatorsTimer = setTimeout(() => {
                this.updateIndicators();
            }, 300);
        }

        const prevInvLen = Object.keys(prevProps.invoicesMap || {}).length;
        const nextInvLen = Object.keys(this.props.invoicesMap || {}).length;

        if (prevInvLen !== nextInvLen || prevProps.invoicesMap !== this.props.invoicesMap) {
        this.setState({ invoicesAmountMonth: getInvoicesAmountMonth(this.props.invoicesMap) });
        }

        const dataChanged =
        prevProps.ticketsMap !== this.props.ticketsMap ||
        prevProps.invoicesMap !== this.props.invoicesMap ||
        prevProps.tasksMap !== this.props.tasksMap;

        const filtersChanged =
        prevState.period !== this.state.period ||
        prevState.type !== this.state.type ||
        prevState.shiftPeriod !== this.state.shiftPeriod;

        const indicatorsChanged = 
        prevState.indicatorsByDay !== this.state.indicatorsByDay ||
        prevState.indicatorsByMonth !== this.state.indicatorsByMonth;

        if (dataChanged || filtersChanged || indicatorsChanged) {
        clearTimeout(this._chartsTimer);
        this._chartsTimer = setTimeout(() => {
            this.loadAllGraphics();
        }, 0);
        }
    }

    componentWillUnmount() {
        clearTimeout(this._chartsTimer);
        clearTimeout(this._indicatorsTimer);
        Object.values(this.charts || {}).forEach(ch => {
            if (ch) ch.destroy();
        });
    }

    updateTasksByState = () => {
        findTasksByState(0).then(data => {
            this.setState({ waitingAmount: this.calculateAmountTotal(data) })
        })

        findTasksByState(3).then(data => {
            this.setState({ waitingReplacementAmount: this.calculateAmountTotal(data) })
        })

        findTasksByState(5).then(data => {
            this.setState({ rmaAmount: this.calculateAmountTotal(data) })
        })
    }

    updateIndicators = () => {
        getAllIndicatorsByDay().then(indicatorsByDay => {
            this.setState({ indicatorsByDay })
        })

        getAllIndicatorsByMonth().then(indicatorsByMonth => {
            this.setState({ indicatorsByMonth })
        })
    }

    calculateAmountTotal = (data) => {
        return Object.values(data).reduce((acc, task) => {
            const budget = isNaN(task.budget) ? 0 : Number(task.budget)
            return acc + budget
        }, 0)
    }

    loadAllGraphics = () => {
    // destruir charts anteriores
    Object.values(this.charts).forEach(ch => {
        if (ch) ch.destroy();
    });

    // crear charts nuevos
    this.charts.tasksAmount = getAmountTasksByPeriod(
    'tasksAmount',
    this.state,
    getTasksData(this.props.tasksMap)
    );

    this.charts.invoicesAmount = getAmountInvoicesByPeriod(
        'invoicesAmount',
        this.state,
        getInvoicesData(this.props.invoicesMap)
    );

    this.charts.ticketsAmount = getAmountTicketByPeriod(
        'ticketsAmount',
        this.state,
        getTicketsList(this.props.ticketsMap)
    );

    this.charts.clientsType = getClientsTypeByPeriod(
    'clientsType',
    this.state,
    this.props.tasksMap
    );

    this.charts.numberTasks = getNumberTasksByPeriod(
        'numberTasks',
        this.state,
        getTasksData(this.props.tasksMap)
    );
    }

    render() {
       const indicators = [
        { label: "Ticket diario efectivo", value: renderMoney(this.state.ticketsCashToday, true), icon: cls => <LocalAtm className={cls} /> },
        { label: "Ticket diario tarjeta", value: renderMoney(this.state.ticketsCardToday, true), icon: cls => <CreditCard className={cls} /> },
        { label: "Ticket diario total", value: renderMoney(this.state.ticketsTotalToday, true), icon: cls => <Receipt className={cls} /> },
        {
            label: "Ingresos mensuales",
            value: (
            <span className="kpi-money-with-change">
                <span>{renderMoney(this.state.revenueMonth, true)}</span>
                <span
                className={
                    "kpi-change " +
                    (this.state.revenueMoMPercent === null
                    ? "na"
                    : this.state.revenueMoMPercent > 0
                    ? "up"
                    : this.state.revenueMoMPercent < 0
                    ? "down"
                    : "flat")
                }
                >
                {this.state.revenueMoMPercent === null
                    ? "(—)"
                    : `(${this.state.revenueMoMPercent > 0 ? "+" : ""}${this.state.revenueMoMPercent.toFixed(1)}%)`}
                </span>
            </span>
            ),
            icon: cls => (
            <RevenueTrendIcon
                className={cls}
                percent={this.state.revenueMoMPercent}
            />
            )
        },
        {
        label: "Reparaciones pendientes",
        value: this.state.openTasksNow?.total ?? 0,
        icon: cls => <HourglassEmpty className={cls} />
        },
        {
        label: "Reparaciones finalizadas hoy",
        value: (
            <span className="kpi-money-with-change">
            <span>{this.state.repairedToday}</span>

            {(() => {
                const diff = this.state.repairedToday - this.state.repairedYesterday;

                if (diff === 0) {
                return <span className="kpi-change flat">(=)</span>;
                }

                return (
                <span className={"kpi-change " + (diff > 0 ? "up" : "down")}>
                    ({diff > 0 ? "+" : ""}{diff})
                </span>
                );
            })()}
            </span>
        ),
        icon: cls => <Build className={cls} />
        }
        ];

        const graphics = [
            { label: "Reparaciones", chart: "tasksAmount", type: 1 },
            { label: "Facturas", chart: "invoicesAmount", type: 2 },
            { label: "Tickets", chart: "ticketsAmount", type: 3 },
            { label: "Clientes nuevos/recurrentes", chart: "clientsType", type: 4 },
            { label: "Número de tareas", chart: "numberTasks", type: 1 }
        ]

        const status = this.state.openTasksNow;
        const alerts = getWorkshopAlerts(status);

        return (
            <div class="container">
                <div class="indicators">
                    {indicators.map(indicator => (
                        <div className={"indicator " + (indicator.className || "")}>
                            <div className="label">{indicator.label}</div>
                            <div className="value">
                            {indicator.icon("value-background")}
                            <div className="icon">{indicator.icon()}</div>
                            {indicator.value}
                            </div>
                        </div>
                    ))}
                </div>

                {/* Estado general del taller */}
                <div className="workshop-status">
                    <div className="workshop-header">
                        <span className="workshop-title">Estado del taller</span>
                    </div>

                    <div className="workshop-body">
                        {/* IZQUIERDA */}
                        <div className="workshop-left">
                            <div className="workshop-line state-diagnostic">
                            <Build fontSize="small" className="workshop-line-icon" />
                            {status?.diagnostic ?? 0} en reparación
                            </div>

                            <div className="workshop-line state-waiting-parts">
                            <LocalShipping fontSize="small" className="workshop-line-icon" />
                            {status?.waitingParts ?? 0} esperando repuesto
                            </div>

                            <div className="workshop-line state-outside">
                            <FlightTakeoff fontSize="small" className="workshop-line-icon" />
                            {status?.outside ?? 0} enviadas al exterior
                            </div>
                        </div>

                        {/* CENTRO */}
                        <div className="workshop-center">
                            <div className="workshop-line state-waiting-client">
                            <PhoneInTalk fontSize="small" className="workshop-line-icon" />
                            {status?.waitingClient ?? 0} esperando confirmación cliente
                            </div>

                            <div className="workshop-line state-rma">
                            <Autorenew fontSize="small" className="workshop-line-icon" />
                            {status?.rma ?? 0} RMA
                            </div>

                            <div className="workshop-line state-stuck">
                            <AccessTime fontSize="small" className="workshop-line-icon" />
                            {status?.stuck ?? 0} reparaciones atascadas (+7 días)
                            </div>                            
                        </div>

                        {/* DERECHA (alertas) */}
                        <div className="workshop-right">
                            {alerts.map((msg, i) => {
                            const { icon: Icon, cls } = getWorkshopAlertConfig(msg);

                            return (
                                <div key={i} className={`workshop-alert ${cls}`}>
                                <span className="workshop-alert-icon">
                                    <Icon />
                                </span>
                                <span className="workshop-alert-text">{msg}</span>
                                </div>
                            );
                            })}
                        </div>
                    </div>

                </div>

                <div class="graphic-container">
                    <div class="filter">
                        <div class="type">
                            <ButtonGroup color="primary" aria-label="outlined primary button group">
                                <Button onClick={() => this.setState({ type: 0 })} className={this.state.type === 0 ? 'button-active' : ''}>Todos</Button>
                                <Button onClick={() => this.setState({ type: 1 })} className={this.state.type === 1 ? 'button-active' : ''}>Tareas</Button>
                                <Button onClick={() => this.setState({ type: 2 })} className={this.state.type === 2 ? 'button-active' : ''}>Facturas</Button>
                                <Button onClick={() => this.setState({ type: 3 })} className={this.state.type === 3 ? 'button-active' : ''}>Tickets</Button>
                                <Button onClick={() => this.setState({ type: 4 })} className={this.state.type === 4 ? 'button-active' : ''}>Clientes</Button>
                            </ButtonGroup>
                        </div>
                        <div class="period">
                            <IconButton color='primary' onClick={() => this.setState({ shiftPeriod: this.state.shiftPeriod - 1}) }>
                                <ArrowBackIos />
                            </IconButton>
                            <label>Periodo</label>
                            <Select style={{ width: '100%' }} value={this.state.period} onChange={ev => this.setState({ period: ev.target.value, shiftPeriod: 0 })}>
                                <MenuItem value={'daily'}>
                                    Diario
                                </MenuItem>
                                <MenuItem value={'monthly'}>
                                    Mensual
                                </MenuItem>
                                <MenuItem value={'quarterly'}>
                                    Trimestral
                                </MenuItem>
                                <MenuItem value={'yearly'}>
                                    Anual
                                </MenuItem>
                            </Select>
                            <IconButton style={{ paddingRight: '8px' }} color='primary' disabled={this.state.shiftPeriod === 0} onClick={() => this.setState({ shiftPeriod: this.state.shiftPeriod + 1}) }>
                                <ArrowForwardIos />
                            </IconButton>
                            <IconButton style={{ paddingLeft: 0 }} color='primary' disabled={this.state.shiftPeriod === 0} onClick={() => this.setState({ shiftPeriod: 0}) }>
                                <SkipNext />
                            </IconButton>
                        </div>
                    </div>
                    <div class="graphics">
                        {graphics.filter(graphic => this.state.type === 0 || this.state.type === graphic.type)
                            .map(graphic => (
                                <div class="graphic">
                                    <div class="label">{graphic.label}</div>
                                    <canvas
                                        id={graphic.chart}>
                                    </canvas>
                                </div>
                            ))}
                    </div>
                </div>
            </div>
        )
    }
}

const mapDispatchToProps = dispatch => ({
    getTickets: payload => dispatch(getTicketsAction(payload)),
    getInvoices: payload => dispatch(getInvoices(payload)),
    getTasks: payload => dispatch(getTasks(payload))
})

const mapStateToProps = state => ({
    ticketsMap: state.tickets.data,
    invoicesMap: state.invoices.data,
    tasksMap: state.tasks.data,
    ticketDetailMap: state.ticketDetail?.data || {}
})

export default connect(mapStateToProps, mapDispatchToProps)(DashboardContainer)